export const misRoles = {
  methods: {
    getRol(mapContrato) {
      let rolesUsuario = [];
      for (const prop in mapContrato[0]) {
        if (mapContrato[0].hasOwnProperty(prop)) {
          rolesUsuario.push(mapContrato[0][prop]);
        }
      }
      return rolesUsuario;
    },
    getUsuRolContrato(datos) {
      for (const prop in datos) {
        if (datos.hasOwnProperty(prop)) {
          return this.getRolList(datos[prop]);
        }
      }
    },

    getRolList(cont) {
      let rol;
      for (const prop in cont) {
        if (cont.hasOwnProperty(prop)) {
          rol = cont[prop];
        }
      }
      this.$store.commit("rolInContract_state", rol[0]);
      return rol;
    },

    hasPermission(rol, lstRoles) {
      return lstRoles.includes(rol);
    },
  },
};
